import React, { useCallback, useEffect, useRef, useState } from 'react';
import apiService from '../services/api';
import TempStart from './TempStart';
import AppShell from '../components/AppShell';
import { ReactComponent as PlaneIcon } from '../assets/icons/plane.svg';
import '../styles/Travel.css';

function errorText(error) {
  return error?.response?.data?.error || error?.message || 'Failed to open Travel';
}

function TravelPage() {
  const [travelUrl, setTravelUrl] = useState('');
  const [loading, setLoading] = useState(true);
  const [frameReady, setFrameReady] = useState(false);
  const [error, setError] = useState('');
  const requestRef = useRef(0);

  const loadSession = useCallback(async () => {
    const requestId = requestRef.current + 1;
    requestRef.current = requestId;
    setLoading(true);
    setError('');
    setFrameReady(false);
    setTravelUrl('');
    try {
      const session = await apiService.createTravelSession();
      if (requestRef.current !== requestId) return;
      const embedPath = session?.embed_path;
      if (!embedPath) throw new Error('No travel session from server');
      setTravelUrl(`${apiService.getApiOrigin()}${embedPath}`);
    } catch (err) {
      if (requestRef.current !== requestId) return;
      setError(errorText(err));
    } finally {
      if (requestRef.current === requestId) setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadSession();
  }, [loadSession]);

  const showOverlay = !error && (loading || (travelUrl && !frameReady));

  return (
    <div className="travel-page">
      <section className="travel-earn">
        <span className="travel-earn-icon" aria-hidden="true">
          <PlaneIcon />
        </span>
        <span>
          <strong>Earn points as you travel</strong>
          <em>1 point per $1 spent</em>
        </span>
      </section>
      <div className="travel-body">
        {error ? (
          <div className="travel-error">
            <p>{error}</p>
            <button type="button" onClick={loadSession}>
              Try again
            </button>
          </div>
        ) : null}
        {travelUrl ? (
          <iframe
            className={`travel-frame${frameReady ? '' : ' is-loading'}`}
            title="Travel"
            src={travelUrl}
            onLoad={() => setFrameReady(true)}
          />
        ) : null}
        {showOverlay ? <div className="travel-loading">Loading Travel...</div> : null}
      </div>
    </div>
  );
}

function TravelGate() {
  if (!apiService.isAuthenticated()) return <TempStart />;
  return (
    <AppShell title="Travel">
      <TravelPage />
    </AppShell>
  );
}

export default TravelGate;
